import authIdInputValue$ from '../../../selectors/getUserId';
import * as ExistSubscriptionActions from '../actions/existSubscription';
import subToasterContentAndTypeCreator from './subToaster/subToasterContentAndType';

import * as Const from '../constants';
import * as Api from '../utils/api';

import ReduxAction from '../../../interfaces/ReduxAction';

export default function reloadExistSubscription (): ReduxAction {
  return (dispatch, getState): void => {

    Api.subscriptionGetById(authIdInputValue$(getState()))
      .then(response => {
        dispatch(ExistSubscriptionActions.existSubSubscription(response.data));
        dispatch(ExistSubscriptionActions.existSubNotLoading());
        if (response.data.data === null) {
          dispatch(subToasterContentAndTypeCreator(
            Const.SUBSCRIPTION_MESSAGE.loadExist.warning,
            Const.MESSAGE_TYPE.warning
          ));
        }
      })
      .catch(reason => {
        dispatch(subToasterContentAndTypeCreator(
          reason,
          Const.MESSAGE_TYPE.fail
        ));
        dispatch(ExistSubscriptionActions.existSubNotLoading());
      });
  };
}
